import React from "react";
import { Spin } from "antd";

class ScLayoutMicroAppContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    // console.log("shouldComponentUpdate",'nextProps:',nextProps,'props:',this.props,JSON.stringify(nextProps) !== JSON.stringify(this.props));
    return JSON.stringify(nextProps) !== JSON.stringify(this.props);
  }

  render() {
    const subAppContainers = [];
    Object.keys(this.props.frames).forEach((key) => {
      const frame = this.props.frames[key];
      if (
        typeof frame === "object" &&
        frame.isMicroApp &&
        !subAppContainers.find((app) => app.name === frame.name)
      ) {
        subAppContainers.push(frame);
      }
    });

    // console.log("子应用容器render");

    return (
      <div>
        {subAppContainers.map((frame) => {
          const display = this.props.currMicroAppName === frame.name ? "block" : "none";

          return (
            <Spin
              key={frame.name}
              spinning={Boolean(this.props.loading && this.props.currMicroAppName === frame.name)}>
              <div
                id={`microapp_${frame.name}`}
                style={{
                  display,
                  overflow: "auto",
                  borderRadius: "4px",
                  minHeight: "400px",
                  height: "calc(100vh - 200px)",
                }}
                className={`sub-app-container default-page ${frame.extraCls}`}></div>
            </Spin>
          );
        })}
      </div>
    );
  }
}

export default ScLayoutMicroAppContainer;



// WEBPACK FOOTER //
// ./src/AntD/components/layout/scLayoutMicroAppContainer.js